// Auto-generated endpoint map
export const ENDPOINTS = {
  AliveAlive: '/api/General/Identity/alive',
  AppointmentGetAccessInfo: '/api/General/Appointment/{callTicket}/accessInfo',
  AppointmentGetCalendarInfo: '/api/General/Appointment/{callTicket}/calendarInfo',
  AppointmentGetRedRobinSessionId: '/api/General/Appointment/{bookingId}/redRobinSession',
  AppointmentGetVideoCallInfo: '/api/General/Appointment/{callTicket}/videocallInfo',
  ClinicalNotesExportCallbackHandleClinicalNotesExportCallback: '/api/General/ClinicalNotesExportCallback',
  CountriesGetSystemCountries: '/api/General/Countries',
  ExternalDataGetExternalData: '/api/General/ExternalData/{externalDataId}',
  FeatureTogglesGetByGlobalCustomerId: '/api/General/FeatureToggles/ByGlobalCustomerId',
  FeatureTogglesGetFeatureToggles: '/api/General/FeatureToggles',
  GeneralIdentitySignOut: '/api/General/Identity/signOut',
  GeneralThemeGetHolderTheme: '/api/General/Theme/holder/{licenceHolderId}',
  IdpAuthenticationChallengeClient: '/api/auth/{licenceHolderId}/{authType}/{remoteScheme}/challenge',
  IdpAuthenticationChallengeOvermind: '/api/auth/{authType}/challenge',
  LanguageGetSystemLanguages: '/api/General/Language',
  LanguageSetLanguage: '/api/General/Language/SetLanguage',
  LanguagesGetSystemLanguages: '/api/General/Languages',
  LicenceHolderGetLicenceHolderId: '/api/General/LicenceHolder/{urlAlias}',
  LicenceHolderGetOfficeBaseByAlias: '/api/General/LicenceHolder/{urlAlias}/officebase',
  LicenceHolderGetPatientPolicyDocuments: '/api/General/LicenceHolder/{urlAlias}/patient/policyDocuments',
  LicenceHolderGetPublicBaseByAlias: '/api/General/LicenceHolder/{urlAlias}/publicbase',
  LicenceHolderGetPublicBaseByAliasConsiderDomain: '/api/General/LicenceHolder/publicbase',
  LicenceHolderGetPublicBaseRouteInfoByAliasConsiderDomain: '/api/General/LicenceHolder/public/routeinfo',
  LicenceHolderGetUrlAlias: '/api/General/LicenceHolder/{licenceHolderId}/alias',
  RedRobinCreateNavigationSession: '/api/General/RedRobin/CreateNavigationSession',
  RedRobinGetRepresentativeNin: '/api/General/RedRobin/{sessionId}/GetRepresentativeNin',
  RedRobinGetSession: '/api/General/RedRobin/{sessionId}',
  RedRobinNavigate: '/api/General/RedRobin/Navigate',
  SessionTouch: '/api/General/Session/touch',
  SessionTouch2: '/api/General/Session/touch',
  SorryGetSorry: '/api/General/Sorry',
  TimeZonesGetSystemTimeZones: '/api/General/TimeZones',
  TranslationSetsGet: '/api/General/TranslationSets/{licenceHolderId}/{translationSets}/{languageCode}',
  TurnTestReportTurnTest: '/api/General/TurnTest/Report/Participant/{participantId}',
  VerificationAttemptsBeginPhoneVerificationAttempt: '/api/General/LicenceHolders/{licenceHolderId}/VerificationAttempts/Phone',
  VerificationAttemptsCompleteVerificationAttempt: '/api/General/LicenceHolders/{licenceHolderId}/VerificationAttempts/{verificationAttemptId}',
  VideoCallBackgroundGet: '/api/General/VideoCallBackground'
} as const;

export type EndpointKey = keyof typeof ENDPOINTS;
export type EndpointUrl = typeof ENDPOINTS[EndpointKey];
